module.exports = __webpack_public_path__ + "71ddcf5f2f49cc41289957b547bcc7fe.png";